// extracted by mini-css-extract-plugin
var _1 = "uB5ZM";
var _2 = "hgjeQ";
var _3 = "KwttI";
var _4 = "IST2q";
export { _1 as "actions", _2 as "actionsLeft", _3 as "form", _4 as "header" }
